import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import xeroAuth from '../services/xeroAuth';

/** One token exchange even if React StrictMode runs the effect twice in dev. */
let tokenExchange: Promise<void> | null = null;

function exchangeCodeOnce(query: string): Promise<void> {
  if (!tokenExchange) {
    tokenExchange = xeroAuth.handleCallback(query).finally(() => {
      tokenExchange = null;
    });
  }
  return tokenExchange;
}

const AuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      const oauthError = searchParams.get('error');
      if (oauthError) {
        if (!cancelled) {
          setError(searchParams.get('error_description') || oauthError);
        }
        return;
      }
      const q = searchParams.toString();
      if (!q) {
        if (!cancelled) {
          setError('Missing OAuth parameters');
        }
        return;
      }
      try {
        await exchangeCodeOnce(q);
        if (!cancelled) {
          navigate('/', { replace: true });
        }
      } catch (e) {
        if (!cancelled) {
          setError(e instanceof Error ? e.message : 'Authentication failed');
        }
      }
    };

    void run();
    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  if (error) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="error" sx={{ mb: 2 }}>
          {error}
        </Typography>
        <Button variant="contained" href="/login">
          Back to login
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
      <CircularProgress />
    </Box>
  );
};

export default AuthCallback;
